import { Link } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";
import { ArrowLeft } from "lucide-react";

const TermsPage = () => {
  usePageTitle('Terms & Conditions', 'Advanta Plus customer terms and conditions');

  return (
    <div className="min-h-screen bg-[#020617] py-12 px-6">
      <Link
        to="/"
        className="fixed top-6 left-6 flex items-center gap-2 text-white/60 hover:text-[#D4AF37] transition-colors z-10"
      >
        <ArrowLeft className="w-5 h-5" />
        <span>Back</span>
      </Link>

      <div className="max-w-3xl mx-auto pt-12">
        <div className="text-center mb-10">
          <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#D4AF37] to-[#B8860B] flex items-center justify-center mx-auto mb-4 shadow-lg">
            <span className="text-[#020617] font-bold text-xl tracking-tight">A+</span>
          </div>
          <h1 className="font-['Playfair_Display'] text-3xl text-white mb-2">Customer Terms & Conditions</h1>
          <p className="text-white/50">Términos y Condiciones para Clientes</p>
        </div>

        <div className="bg-[#0B0F19] rounded-2xl p-8 border border-[#D4AF37]/10 space-y-10">
          {/* English Version */}
          <div>
            <h2 className="text-[#D4AF37] font-semibold text-lg uppercase tracking-wider mb-6">English Version</h2>

            <div className="space-y-6 text-white/80 text-sm leading-relaxed">
              <div>
                <h3 className="text-white font-semibold mb-1">1. Introduction</h3>
                <p>These Terms govern the use of the Advanta+ digital membership card.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">2. How the Card Works</h3>
                <p>Provides access to discounts at participating outlets.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">3. Validity & Usage</h3>
                <p>Card is valid for selected duration. Cardholder must be present.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">4. Group Usage</h3>
                <p>A single Advanta+ card applies to the cardholder and the entire group accompanying them on a single bill, with no limit on the number of people in the group. The cardholder must be present at the time of purchase.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">5. Discounts & Exclusions</h3>
                <p>Offers vary by outlet and may include restrictions.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">6. Validation</h3>
                <p>Must be shown before requesting the bill via QR or digital display.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">7. Fair Use</h3>
                <p>Misuse or abuse may result in suspension.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">8. Non-Transferable</h3>
                <p>Card is personal and cannot be shared.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">9. Refund Policy</h3>
                <p>Non-refundable unless required by law.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">10. Liability</h3>
                <p>Advanta+ not responsible for outlet services.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">11. Changes</h3>
                <p>Advanta+ may update programme and terms.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">12. Data Protection</h3>
                <p>GDPR compliant.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">13. Governing Law</h3>
                <p>Spain.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">14. Acceptance</h3>
                <p>Use implies acceptance.</p>
              </div>
            </div>
          </div>

          <hr className="border-white/10" />

          {/* Spanish Version */}
          <div>
            <h2 className="text-[#D4AF37] font-semibold text-lg uppercase tracking-wider mb-6">Versión en Español</h2>

            <div className="space-y-6 text-white/80 text-sm leading-relaxed">
              <div>
                <h3 className="text-white font-semibold mb-1">1. Introducción</h3>
                <p>Uso de la tarjeta digital Advanta+.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">2. Funcionamiento</h3>
                <p>Acceso a descuentos en establecimientos.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">3. Validez y Uso</h3>
                <p>Válida durante el periodo seleccionado. El titular debe estar presente.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">4. Uso en Grupo</h3>
                <p>Una sola tarjeta Advanta+ aplica al titular y a todo el grupo que le acompañe en una única cuenta, sin límite en el número de personas del grupo. El titular debe estar presente en el momento de la compra.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">5. Descuentos</h3>
                <p>Pueden aplicarse restricciones según el establecimiento.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">6. Validación</h3>
                <p>Debe mostrarse antes de pedir la cuenta.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">7. Uso Responsable</h3>
                <p>El uso indebido puede causar suspensión.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">8. Uso Personal</h3>
                <p>No transferible.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">9. Reembolsos</h3>
                <p>No reembolsable salvo ley.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">10. Responsabilidad</h3>
                <p>Advanta+ no es responsable del servicio.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">11. Cambios</h3>
                <p>Advanta+ puede modificar condiciones.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">12. Protección de Datos</h3>
                <p>Cumplimiento RGPD.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">13. Legislación</h3>
                <p>España.</p>
              </div>

              <div>
                <h3 className="text-white font-semibold mb-1">14. Aceptación</h3>
                <p>El uso implica aceptación.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
